import I18n from 'i18n-js';
import React from 'react';
import BasicPageHead from './basic_page_head';
import CMSCenteredPageHead from '../cms/headers/cms_centered_page_head';
import CMSBuyingGuidePageHead from '../cms/headers/cms_buying_guide_page_head';
import CMSPageHead from '../cms/headers/cms_page_head';
import SearchHeader from '../cms/headers/search_header';
import { BreadcrumbData } from '../cms/components/breadcrumb_navigation';

interface IProps {
  actionText: string;
  actionUrl: string;
  authorName: string;
  goLiveAt: string;
  headerStyle: string;
  imageUrl: string;
  pageType: string;
  searchPlaceholder: string;
  subtitle: string;
  title: string;
  secondaryImageUrl: string;
  breadcrumbs?: Array<BreadcrumbData>;
}

export default class DynamicPageHead extends React.PureComponent<IProps, null> {
  get actionText() {
    return this.props.actionText || I18n.t('commons.dynamicPageHead.actionText');
  }

  get searchPlaceholder() {
    return this.props.searchPlaceholder || I18n.t('commons.dynamicPageHead.searchPlaceholder');
  }

  render() {
    switch (this.props.headerStyle) {
      case 'none': return null;
      case 'style1': // Offset Right
        return (
          <CMSPageHead
            actionText={this.actionText}
            actionUrl={this.props.actionUrl}
            imageUrl={this.props.imageUrl}
            subtitle={this.props.subtitle}
            title={this.props.title}
            pageType={this.props.pageType}
            authorName={this.props.authorName}
            goLiveAt={this.props.goLiveAt}
          />
        );
      case 'style2': // Centered
        return (
          <CMSCenteredPageHead
            actionText={this.actionText}
            actionUrl={this.props.actionUrl}
            imageUrl={this.props.imageUrl}
            searchPlaceholder={this.searchPlaceholder}
            subtitle={this.props.subtitle}
            title={this.props.title}
          />
        );
      case 'style3':
      case 'style4':
      case 'style5':
      case 'style6':
        return (
          <BasicPageHead
            actionText={this.actionText}
            actionUrl={this.props.actionUrl}
            backgroundImage={this.props.imageUrl}
            headerStyle={this.props.headerStyle}
            searchPlaceholder={this.searchPlaceholder}
            subtitle={this.props.subtitle}
            title={this.props.title}
            breadcrumbs={this.props.breadcrumbs}
          />
        );
      case 'style7':
        return (
          <CMSBuyingGuidePageHead
            imageUrl={this.props.imageUrl}
            subtitle={this.props.subtitle}
            title={this.props.title}
          />
        );
      case 'style8':
        return (
          <SearchHeader
            subtitle={this.props.subtitle}
            title={this.props.title}
            imageUrl={this.props.imageUrl}
            secondaryImageUrl={this.props.secondaryImageUrl}
            searchPlaceholder={this.searchPlaceholder}
            actionText={this.actionText}
            actionUrl={this.props.actionUrl}
          />
        );
      default:
        return null;
    }
  }
}
